<template>
    <div>
   <!-- Breadcrumb Section Begin -->
   <div class="breacrumb-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text">
                        <a href="#"><i class="fa fa-home"></i> {{ $t('nav.home') }}</a>
                        <span> {{ NomeCategoria }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Breadcrumb Section Begin -->

 <!-- Pacotes nacionais -->
 <section class="product-shop spad" v-if="SegmentosMenu!=''">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-8 order-2 order-lg-1 produts-sidebar-filter">
                    <div class="filter-widget">
                        <h4 class="fw-title">{{ $t('products.categories') }}</h4>
                        <ul class="filter-catagories">
                            <li v-for="seg in SegmentosMenu" :key="seg.psgId">
                                <a href="#" @click.prevent="MontaUrl(seg.psgNomeSegmento, seg.psgId)" style="font-size: 16px;">
                                  {{ $localeField(seg, 'psgNomeSegmento') }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-widget">
                        <h4 class="fw-title">{{ $t('products.countries') }}</h4>
                        <v-select v-model="nomePais" :items="paises" :label="$t('common.select')"
                            @update:modelValue="FiltrarProdutoPais(nomePais)" item-title="nome"
                            item-value="valor" variant="underlined" style="width: 180px;">
                        </v-select>
                    </div>
                    <div class="filter-widget">
                        <h4 class="fw-title">{{ $t('products.distance') }}</h4>
                        <div class="fw-tags">
                            <a v-for="(itdist,index) in distancias" :key="index" href="#" @click.prevent="FiltroDistancia(itdist.valor)">{{itdist.nome}}</a>                      
                        </div>
                    </div>
                </div>
                <!-- dropdown meses -->
                <div class="col-lg-9 order-1 order-lg-2">
                    <div class="product-show-option">
                        <div class="row">
                            <div class="col-lg-3 col-md-4">
                                <div class="select-option">
                                        <v-select v-model="mes" :items="meses" :label="$t('products.period')"
                                            @update:modelValue="FiltrarProdutosMes(mes)" item-title="nome"
                                            item-value="valor" variant="underlined" style="width: 180px;">
                                        </v-select>
                                 </div>
                            </div>
                            <div  class="col-lg-3 col-md-4">
                                <v-select v-model="Ordenacao" :items="OrdenacaoAtivo" :label="$t('products.sortBy')"
                                            @update:modelValue="OrdenaProdutos(Ordenacao)" item-title="nome"
                                            item-value="valor" variant="underlined" style="width: 180px;">
                                        </v-select>
                            </div>
                            <div class="col-lg-6 col-md-4 text-right">
                                <h2>{{ NomeCategoria }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="product-list" v-if="ProdutosFiltro != ''">
                        <div class="row">
                            <div class="col-lg-4 col-sm-6" v-for="prod4car in ProdutosFiltro" :key="prod4car.proProdutos.proId">
                                <div class="product-item">
                                    <div class="pi-pic">
                                        <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">
                                           <img  v-if="prod4car.proProdutos.proCampoExtra10 != '' && prod4car.proProdutos.proCampoExtra10 != null" :src="$imgURL + prod4car.proProdutos.proCampoExtra10" alt="" style="height: 175px;">
                                        </router-link>
                                        <div class="sale" v-if="prod4car.proProdutos.proEtiqueta != '' && prod4car.proProdutos.proEtiqueta != null"
                                        :style="{
                                            color: prod4car.proProdutos.proEtiquetaCorFonte ? `${prod4car.proProdutos.proEtiquetaCorFonte} !important` : '#FFFFFF !important', 
                                            backgroundColor: prod4car.proProdutos.proEtiquetaCorFundo ? `${prod4car.proProdutos.proEtiquetaCorFundo} !important` : '#76BC42 !important'
                                        }"
                                        >{{ $localeField(prod4car.proProdutos, 'proEtiqueta') }}</div>
                                        <ul>
                                            <li class="quick-view">
                                                <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">{{ $t('home.moreDetails') }}</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="pi-text">
                                        <div class="catagory-name">{{ $localeField(prod4car.proProdutos, 'proReferencia') }}</div>
                                        <div class="catagory-name">{{ $localeField(prod4car.proProdutos, 'proCampoExtra2') }}</div>
                                            <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">
                                                <h5>{{ $localeField(prod4car.proProdutos, 'proNomeProduto') }}</h5>
                                            </router-link>
                                        <div class="product-price" v-if="prod4car.proProdutos.proValorPor > 0">
                                            {{ $t('home.fromPrice') }} R$ {{ formatarValor(prod4car.proProdutos.proValorPor) }}
                                        </div>
                                        <div class="product-price" v-else>
                                            {{ $t('home.consultPrice') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Final pacotes nacionais -->
    </div>
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
    name: 'ProdutosView',
    setup() {
        const route = useRoute();
        const id = route.params.idSegmentoProduto;
        const nomeSeg = route.params.nomeSegmento;
        const pesquisa = route.params.chavepesquisa;
        return {
            id,pesquisa
        };
    },
    components: {
        Swiper,
    SwiperSlide,
    },
    data: () => ({
        informacoestopo: [],
        produtosSegmentos: [],
        Segmentos: [],
        SegmentosMenu: [],
        ProdutosGeral:[],
        ProdutosFiltro: [],
        infocall: [],
        CategoriaClicada: false,
        NomeCategoria: '',
        Ordenacao: null,
        SegmentosSubMenu:[],
        mes: null,
        paises:[],
        nomePais: null,
        distancias:[],
        distancia: null,
    }),
    computed: {
        meses() {
            return [
                { nome: this.$t('months.all'), valor: '0' },
                { nome: this.$t('months.1'), valor: '1' },
                { nome: this.$t('months.2'), valor: '2' },
                { nome: this.$t('months.3'), valor: '3' },
                { nome: this.$t('months.4'), valor: '4' },
                { nome: this.$t('months.5'), valor: '5' },
                { nome: this.$t('months.6'), valor: '6' },
                { nome: this.$t('months.7'), valor: '7' },
                { nome: this.$t('months.8'), valor: '8' },
                { nome: this.$t('months.9'), valor: '9' },
                { nome: this.$t('months.10'), valor: '10' },
                { nome: this.$t('months.11'), valor: '11' },
                { nome: this.$t('months.12'), valor: '12' },
            ];
        },
        OrdenacaoAtivo() {
            return [
                { nome: this.$t('products.sortAZ'), valor: 1 },
                { nome: this.$t('products.sortZA'), valor: 2 },
                { nome: this.$t('products.sortHighPrice'), valor: 3 },
                { nome: this.$t('products.sortLowPrice'), valor: 4 },
            ];
        },
    },
    methods: {
        carregaMetas() {
            useHead({
                title: 'Pacotes - Sub4 Turismo'
            })
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        carregaTexto(value) {
            this.informacao = this.informacoes.filter(x => x.itiId == value)
        },
        OrdenaProdutos(value) {
            if (value == 1) {
                this.ProdutosFiltro = this.ProdutosFiltro.sort((a, b) => {
                    const nomeA = a.proProdutos.proNomeProduto || "";
                    const nomeB = b.proProdutos.proNomeProduto || "";
                    return nomeA.localeCompare(nomeB);
                });
            }
            else if (value == 2) {
                this.ProdutosFiltro = this.ProdutosFiltro.sort((a, b) => {
                    const nomeA = a.proProdutos.proNomeProduto || "";
                    const nomeB = b.proProdutos.proNomeProduto || "";
                    return nomeA.localeCompare(nomeB);
                }).reverse();
            }
            else if (value == 3) {
                this.ProdutosFiltro = this.ProdutosFiltro.sort((a, b) => {
                    const valorA = parseInt(a.proProdutos.proValorPor) || 0;
                    const valorB = parseInt(b.proProdutos.proValorPor) || 0;
                    return valorA - valorB;
                }).reverse();
            }
            else if (value == 4) {
                this.ProdutosFiltro = this.ProdutosFiltro.sort((a, b) => {
                    const valorA = parseInt(a.proProdutos.proValorPor) || 0;
                    const valorB = parseInt(b.proProdutos.proValorPor) || 0;
                    return valorA - valorB;
                });
            }

        },
        FiltrarProdutosMes(mes){
            if (mes != 0){
            this.ProdutosFiltro = this.ProdutosGeral.filter(x=> x.proProdutos.proVisivel && x.proSegmentos.psgId == this.id && x.proProdutos.proCampoExtra1 == mes).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });
            }
            else{
                this.ProdutosFiltro = this.ProdutosGeral.filter(x=> x.proProdutos.proVisivel && x.proSegmentos.psgId == this.id).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });
            }
         this.OrdenaProdutos(this.Ordenacao);
         this.nomePais = null;
        },
        FiltrarProdutoPais(nomePais){
            this.ProdutosFiltro = this.ProdutosGeral.filter(x=> x.proProdutos.proVisivel && x.proSegmentos.psgId == this.id && x.proProdutos.proCampoExtra3 == nomePais).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });
            this.OrdenaProdutos(this.Ordenacao);
            this.mes=null;
        },
        FiltroDistancia(valor1){
            function containsExactValue(field, searchValue) {
                        // Divide o campo em partes, remove espaços extras e compara com o valor pesquisado
                        return field
                            .split(/,\s*|\s+e\s+/)  // Divide a string por vírgula e pela palavra "e", considerando possíveis espaços
                            .map(value => value.trim().toLowerCase())  // Remove espaços em branco e converte para minúsculas
                            .includes(searchValue.toLowerCase());  // Verifica se o valor pesquisado está presente
                        }

                        // Filtrando e ordenando os produtos
                        this.ProdutosFiltro = this.ProdutosGeral
                        .filter(x => 
                            x.proProdutos.proVisivel && 
                            x.proSegmentos.psgId == this.id &&
                            containsExactValue(x.proProdutos.proCampoExtra2, valor1)  // Verifica se o campo contém o valor exato
                        )
                        .sort((a, b) => {
                            const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                            const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                            return valorA - valorB;  // Ordena de forma crescente
                        });
            this.OrdenaProdutos(this.Ordenacao);
            this.mes=null;
            this.nomePais = null;
        },
        MontaUrl(nomeSegmento, psgId) {
            this.$router.push({
                name: 'Produtos',
                params: {
                    idSegmentoProduto: psgId,
                    nomeSegmento: nomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', ''),
                },
                replace: true,
            });
        },
        filtraProdutos(nomeSegmento, psgId){
            this.ProdutosFiltro = this.ProdutosGeral.filter(x=> x.proProdutos.proVisivel && x.proSegmentos.psgId == psgId).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });

                this.NomeCategoria = nomeSegmento;
        },
        AjustaUrl(value, nome) {
            let urlFriendlyNomeProduto = nome
                .normalize("NFD") // Normaliza para decompor os caracteres acentuados
                .replace(/[\u0300-\u036f]/g, "") // Remove os caracteres acentuados
                .replace(/[^\w\s-]/g, "") // Remove caracteres especiais
                .replace(/\s+/g, "-") // Substitui espaços em branco por hífens
                .toLowerCase(); // Converte para minúsculas

            return `${value}/${urlFriendlyNomeProduto}`;
        },
    },
    async created() {
        this.carregaMetas();

        await axios.get('/Process/ProProdutosSegmentos/GetAllBySite')
                    .then(response => {
                        //console.log(response.data)
                        this.ProdutosGeral = response.data;
                        this.ProdutosGeral = this.ProdutosGeral.sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });
                        console.log('this.ProdutosGeral')
                        console.log(this.ProdutosGeral)

                        this.paises = this.ProdutosGeral
                                    .map(item => item.proProdutos.proCampoExtra3)  // Extrai o valor de `proCampoExtra3`
                                    .filter(value => value !== null && value !== undefined && value.trim() !== '')  // Filtra valores não nulos e não vazios
                                    .filter((value, index, self) => self.indexOf(value) === index)  // Filtra valores únicos
                                    .map(value => ({ nome: value, valor: value }));

                                        // Processamento para extrair valores distintos, normalizar, e ordenar
                                        const uniqueValues = [...new Set(
                                        this.ProdutosGeral
                                            .flatMap(item => item.proProdutos.proCampoExtra2
                                            .split(/,\s*|\s+e\s+/)  // Divide a string por vírgula e pela palavra "e", considerando possíveis espaços
                                            .map(value => value.trim().toLowerCase())  // Remove espaços em branco e converte para minúsculas
                                            .filter(value => value && value !== null && value !== undefined)  // Filtra valores não nulos e não vazios
                                            )
                                        )];

                                        // Ordena os valores extraídos
                                        const sortedValues = uniqueValues.sort((a, b) => {
                                        // Função de comparação para ordenar os valores
                                        const numA = parseInt(a, 10); // Extrai o número da string
                                        const numB = parseInt(b, 10); // Extrai o número da string
                                        return numA - numB; // Ordena de forma crescente
                                        });

                                        // Cria o array de objetos
                                        this.distancias = sortedValues.map(value => ({ nome: value, valor: value }));
                    })
                    .catch(error => {
                        console.error(error);
                    });

            await axios.get('/Process/ProSegmentos/GetAll')
                    .then(response => {
                        this.Segmentos = response.data;
                        this.SegmentosMenu = this.Segmentos.filter(x => x.psgIdPai == 0 && x.psgVisivel).sort((a, b) => {
                            const nomeA = a.psgNomeSegmento || "";
                            const nomeB = b.psgNomeSegmento || "";
                            return nomeA.localeCompare(nomeB);
                        });

                        this.NomeCategoria = this.$t('products.packages');
                    })
                    .catch(error => {
                        console.error(error);
                    });


        if (this.pesquisa != null && this.pesquisa != '') {

            let _pesquisa = this.pesquisa.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
           
            let dados = this.ProdutosGeral.filter(x => x.proProdutos.proVisivel && x.proProdutos.proNomeProduto != null).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });
            let dados2 = dados.filter(x => x.proProdutos.proNomeProduto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_pesquisa) != -1 
                || (x.proProdutos.proTexto1!=null && x.proProdutos.proTexto1.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_pesquisa) != -1)
                || (x.proProdutos.proTexto2!=null && x.proProdutos.proTexto2.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_pesquisa) != -1)
                );    

                dados2.forEach(element => {
                    if (this.ProdutosFiltro.filter(x=> x.proProdutos.proId == element.proProdutos.proId).length == 0){
                        this.ProdutosFiltro.push(element);
                    }
                });        
           this.NomeCategoria = this.pesquisa;
        }
        else {
            if (this.id == null || this.id == '' || this.id == 0) {
                let dados = this.ProdutosGeral.filter(x=> x.proProdutos.proDestaque);
                   dados.forEach(element => {
                        if (this.ProdutosFiltro.filter(x=> x.proProdutos.proId == element.proProdutos.proId).length == 0){
                            this.ProdutosFiltro.push(element);
                        }
                    });                
            }
            else {
                this.ProdutosFiltro = this.ProdutosGeral.filter(x=> x.proProdutos.proVisivel && x.proSegmentos.psgId == this.id).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });

                this.SegmentosSubMenu = this.Segmentos.filter(x => x.psgIdPai ==  this.id && x.psgVisivel).sort((a, b) => {
                                const nomeA = a.psgNomeSegmento || "";
                                const nomeB = b.psgNomeSegmento || "";
                                return nomeA.localeCompare(nomeB);
                            });
                this.NomeCategoria = this.$localeField(this.Segmentos.filter(x=> x.psgId == this.id)[0], 'psgNomeSegmento');
            }
        }
    },
}
</script>

<style>.hhss {
    display: none;
}

.sli p {
    color: #ede3e3 !important;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-content {
  text-align: center;
}

.swiper-image,
.swiper-placeholder {
  height: 100px;
  width: 100px;
  border: 1px solid #B91F1C;
  border-radius: 50%;
}

.swiper-placeholder {
  background-color: #cccccc;
}

.swiper-text {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.toolbox {
    display: flex;
    justify-content: space-between;
}

.toolbox-left {
    flex: 1 !important; /* Isso fará com que ele ocupe o espaço disponível (90% da largura) */
}

</style>
